<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@wielink-application/shared/js/mixins/formInput";
import Input from '@/pages/components/form/input-only/color.vue';

export default {
  mixins: [formInput],
  components: {FormGroup, Input},
  props: {
    'groupClasses' : {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  },
}
</script>

<template>
  <FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
    <template #label>{{ label }}</template>

    <Input
        v-bind="$attrs"
        :form="form"
        :name="name"
        :id="renderedId"
        :model-value="modelValue"
        @update:modelValue="changeModelValueTo"
    />
  </FormGroup>
</template>